.item {
  display: flex;
  flex-shrink: 0;
  gap: 7px;
  align-items: center;
  overflow: hidden;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
}

.wrapper {
  overflow: hidden;
  white-space: nowrap;
}

.link:hover {
  text-decoration: underline;
}

.pressReleaseRoot {
  @container press-release-root (min-width: 1024px) {
    gap: 12px;

    .wrapper {
      /* TODO: 「...」を表示するか、改行するか確認する */
      text-overflow: ellipsis;
    }
  }
}

.screen {
  @media screen and (width >= 1024px) {
    gap: 12px;

    .wrapper {
      /* TODO: 「...」を表示するか、改行するか確認する */
      text-overflow: ellipsis;
    }
  }
}
